import { injectGlobal } from 'styled-components';

import OneDotWoff from '../../../static/fonts/OneDot.woff';
import OneDotWoff2 from '../../../static/fonts/OneDot.woff2';
import OneDotEot from '../../../static/fonts/OneDot.eot';

import OneDotBoldWoff from '../../../static/fonts/OneDot-Bold.woff';
import OneDotBoldWoff2 from '../../../static/fonts/OneDot-Bold.woff2';
import OneDotBoldEot from '../../../static/fonts/OneDot-Bold.eot';

import OneDotLightWoff from '../../../static/fonts/OneDot-Light.woff';
import OneDotLightWoff2 from '../../../static/fonts/OneDot-Light.woff2';
import OneDotLightEot from '../../../static/fonts/OneDot-Light.eot';

import OneDotExtWoff from '../../../static/fonts/OneDotExt.woff';
import OneDotExtWoff2 from '../../../static/fonts/OneDotExt.woff2';
import OneDotExtEot from '../../../static/fonts/OneDotExt.eot';

import OneDotExtBoldWoff from '../../../static/fonts/OneDotExt-Bold.woff';
import OneDotExtBoldWoff2 from '../../../static/fonts/OneDotExt-Bold.woff2';
import OneDotExtBoldEot from '../../../static/fonts/OneDotExt-Bold.eot';

import OneDotExtBoldItalicWoff from '../../../static/fonts/OneDotExt-BoldItalic.woff';
import OneDotExtBoldItalicWoff2 from '../../../static/fonts/OneDotExt-BoldItalic.woff2';
import OneDotExtBoldItalicEot from '../../../static/fonts/OneDotExt-BoldItalic.eot';

import OneDotCdBoldWoff from '../../../static/fonts/OneDotCd-Bold.woff';
import OneDotCdBoldWoff2 from '../../../static/fonts/OneDotCd-Bold.woff2';
import OneDotCdBoldEot from '../../../static/fonts/OneDotCd-Bold.eot';

import OneDotCdItalicWoff from '../../../static/fonts/OneDotCd-Italic.woff';
import OneDotCdItalicWoff2 from '../../../static/fonts/OneDotCd-Italic.woff2';
import OneDotCdItalicEot from '../../../static/fonts/OneDotCd-Italic.eot';

import OneDotCdBoldItalicWoff from '../../../static/fonts/OneDotCd-BoldItalic.woff';
import OneDotCdBoldItalicWoff2 from '../../../static/fonts/OneDotCd-BoldItalic.woff2';
import OneDotCdBoldItalicEot from '../../../static/fonts/OneDotCd-BoldItalic.eot';

/* import TwoDotsWoff from '../../../static/fonts/TwoDots.woff';
import TwoDotsWoff2 from '../../../static/fonts/TwoDots.woff2';
import TwoDotsEot from '../../../static/fonts/TwoDots.eot';

import TwoDotsBoldWoff from '../../../static/fonts/TwoDots-Bold.woff';
import TwoDotsBoldWoff2 from '../../../static/fonts/TwoDots-Bold.woff2';
import TwoDotsBoldEot from '../../../static/fonts/TwoDots-Bold.eot'; */

injectGlobal`
  @font-face {
    font-family: 'OneDot';
    src: url('${OneDotWoff}') format('woff'),
        url('${OneDotWoff2}') format('woff2'),
        url('${OneDotEot}') format('embedded-opentype');
  }
  @font-face {
    font-family: 'OneDot';
    src: url('${OneDotBoldWoff}') format('woff'),
        url('${OneDotBoldWoff2}') format('woff2'),
        url('${OneDotBoldEot}') format('embedded-opentype');
    font-weight: bold;
  }
  @font-face {
    font-family: 'OneDot';
    src: url('${OneDotLightWoff}') format('woff'),
        url('${OneDotLightWoff2}') format('woff2'),
        url('${OneDotLightEot}') format('embedded-opentype');
    font-weight: 300;
  }
  @font-face {
    font-family: 'OneDotExt';
    src: url('${OneDotExtWoff}') format('woff'),
        url('${OneDotExtWoff2}') format('woff2'),
        url('${OneDotExtEot}') format('embedded-opentype');
  }
  @font-face {
    font-family: 'OneDotExt';
    src: url('${OneDotExtBoldWoff}') format('woff'),
        url('${OneDotExtBoldWoff2}') format('woff2'),
        url('${OneDotExtBoldEot}') format('embedded-opentype');
    font-weight: bold;
  }
  @font-face {
    font-family: 'OneDotExt';
    src: url('${OneDotExtBoldItalicWoff}') format('woff'),
        url('${OneDotExtBoldItalicWoff2}') format('woff2'),
        url('${OneDotExtBoldItalicEot}') format('embedded-opentype');
    font-weight: bold;
    font-style: italic;
  }
  @font-face {
    font-family: 'OneDotCd';
    src: url('${OneDotCdBoldWoff}') format('woff'),
        url('${OneDotCdBoldWoff2}') format('woff2'),
        url('${OneDotCdBoldEot}') format('embedded-opentype');
    font-weight: bold;
  }
  @font-face {
    font-family: 'OneDotCd';
    src: url('${OneDotCdItalicWoff}') format('woff'),
        url('${OneDotCdItalicWoff2}') format('woff2'),
        url('${OneDotCdItalicEot}') format('embedded-opentype');
    font-style: italic;
  }
  @font-face {
    font-family: 'OneDotCd';
    src: url('${OneDotCdBoldItalicWoff}') format('woff'),
        url('${OneDotCdBoldItalicWoff2}') format('woff2'),
        url('${OneDotCdBoldItalicEot}') format('embedded-opentype');
    font-style: italic;
    font-weight: bold;
  }
`


// WEBPACK FOOTER //
// ./src/components/global/typography/font-defs.js